module.exports = __webpack_public_path__ + "img/Pyrolysis_Highway_Eco_2.8829d379.jpg";